import { render, staticRenderFns } from "./LanguageCommonFilters.vue?vue&type=template&id=21200728&"
import script from "./LanguageCommonFilters.vue?vue&type=script&lang=js&"
export * from "./LanguageCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports